import { render, staticRenderFns } from "./smWorkExpanded.vue?vue&type=template&id=4700cbbc&scoped=true&"
import script from "./smWorkExpanded.vue?vue&type=script&lang=js&"
export * from "./smWorkExpanded.vue?vue&type=script&lang=js&"
import style0 from "./smWorkExpanded.vue?vue&type=style&index=0&id=4700cbbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4700cbbc",
  null
  
)

export default component.exports